/* eslint-disable prettier/prettier */
export const FETCH_BIKE_MAKES_LOADING = 'FETCH_BIKE_MAKES_LOADING';
export const FETCH_BIKE_MAKES_ERROR   = 'FETCH_BIKE_MAKES_ERROR';
export const FETCH_BIKE_MAKES_SUCCESS = 'FETCH_BIKE_MAKES_SUCCESS';
